import classNames from "classnames";
import "./HoverMenu.css";

export function HoverMenuItem(props: {
    disabled?: boolean;
    children?: React.JSX.Element | undefined | false;
}) {
    const { children, disabled } = props;
    return children ? (
        <div className={classNames("hover-menu-item", disabled && "disabled")}>
            {children}
        </div>
    ) : null;
}

type HoverMenuItem = typeof HoverMenuItem;

type HoverMenuProps = {
    children:
        | React.ReactElement<HoverMenuItem>
        | (React.ReactElement<HoverMenuItem> | false)[];
};

export function HoverMenu(props: HoverMenuProps) {
    const { children } = props;
    return <div className="hover-menu">{children}</div>;
}
